
























































































import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({
  components: {
    Typography
  }
})
export default class RadioGroup extends Vue {
  @Prop({ required: true }) name!: String;
  @Prop({ required: true }) optionValue!: string;
  @Prop({ default: '' }) value!: any;
  @Prop({ default: '' }) description!: String;
  @Prop({ default: '' }) tag!: String;
  @Prop({ default: '' }) tagColor!: String;
  @Prop({ default: '' }) tagTitle!: String;
  @Prop({ default: false }) defaultValue!: boolean;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: false }) recommended!: boolean;
  @Prop({ default: false }) comingSoon!: boolean;
  @Prop({ default: 'medium' }) size!: 'small' | 'medium';
  @Prop({ default: 'center' }) dotPlacement?: 'center' | 'top';
  @Prop({ default: false }) removeBorder!: boolean;
  @Inject('$validator') public $validator!: Validator;
  toError: boolean = false;

  get checked() {
    return this.value === this.optionValue;
  }

  get isComments() {
    return this.checked && this.$slots['comments'];
  }

  get titleTag() {
    if (this.recommended) return 'Recommended';
    return this.tagTitle;
  }

  @Watch('error')
  onError(newValue: boolean) {
    if (newValue) {
      this.toError = !this.value;
    }
  }

  changeValue() {
    this.toError = false;
    this.$emit('input', this.optionValue);
  }
}
